/* import __COLOCATED_TEMPLATE__ from './composer-fullscreen-prompt.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();